import {
  CreatePointsTransferMembershipData,
  UpdatePointsTransferMembershipData,
} from '@features/membership/services/membership-api/membership-api.service';
import { Action } from '@ngrx/store';
import { HttpError, Membership } from '@rd/types';

export enum MembershipActionTypes {
  LOAD_MEMBERSHIPS = '[TransferConnectV2] Load Memberships',
  LOAD_MEMBERSHIPS_SUCCESS = '[TransferConnectV2] Load Memberships Success',
  LOAD_MEMBERSHIPS_FAIL = '[TransferConnectV2] Load Memberships Fail',
  CREATE_MEMBERSHIP = '[TransferConnectV2] Create Membership',
  CREATE_MEMBERSHIP_SUCCESS = '[TransferConnectV2] Create Membership Success',
  CREATE_MEMBERSHIP_FAIL = '[TransferConnectV2] Create Membership Fail',
  UPDATE_MEMBERSHIP = '[TransferConnectV2] Update Membership',
  UPDATE_MEMBERSHIP_SUCCESS = '[TransferConnectV2] Update Membership Success',
  UPDATE_MEMBERSHIP_FAIL = '[TransferConnectV2] Update Membership Fail',
}

export class LoadMemberships implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS;
}

export class LoadMembershipsSuccess implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS_SUCCESS;

  constructor(public payload: Membership[]) {}
}

export class LoadMembershipsFail implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS_FAIL;

  constructor(public payload: HttpError) {}
}

export class CreateMembership implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP;

  constructor(public payload: CreatePointsTransferMembershipData) {}
}

export class CreateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS;

  constructor(public payload: Membership) {}
}

export class CreateMembershipFail implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export class UpdateMembership implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP;

  constructor(
    public payload: {
      updateMembershipData: UpdatePointsTransferMembershipData;
      isOverlapping?: true;
    },
  ) {}
}

export class UpdateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS;

  constructor(
    public payload: {
      updateMembershipData: UpdatePointsTransferMembershipData;
      membership: Membership;
    },
  ) {}
}

export class UpdateMembershipFail implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export type MembershipActions =
  | LoadMemberships
  | LoadMembershipsSuccess
  | LoadMembershipsFail
  | CreateMembership
  | CreateMembershipSuccess
  | CreateMembershipFail
  | UpdateMembership
  | UpdateMembershipSuccess
  | UpdateMembershipFail;
